import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 tracking-wide">
              三上悠亚<span className="text-accent-500 font-light text-sm ml-1">粉丝站</span>
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              汇集三上悠亚最新动态、作品资讯与粉丝互动内容的官方资讯平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-100 mb-4">
              <a href="#footer-categories" className="hover:text-accent-400 transition-colors">分类导航</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-100 mb-4">
              <a href="#footer-links" className="hover:text-accent-400 transition-colors">快捷链接</a>
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/latest-news" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  最新动态
                </Link>
              </li>
              <li>
                <Link to="/category/works" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  作品全览
                </Link>
              </li>
              <li>
                <Link to="/category/fan-corner" className="text-sm text-background-300 hover:text-accent-400 transition-colors whitespace-nowrap">
                  粉丝天地
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-100 mb-4">
              <a href="#footer-social" className="hover:text-accent-400 transition-colors">关注我们</a>
            </h4>
            <div className="flex items-center gap-4">
              <a href="https://www.youtube.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line text-base"></i>
              </a>
              <a href="https://www.instagram.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="https://x.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="X (Twitter)">
                <i className="ri-twitter-x-line text-base"></i>
              </a>
              <a href="https://www.tiktok.com/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors cursor-pointer" aria-label="TikTok">
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 三上悠亚粉丝站. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}